import { render, staticRenderFns } from "./Afbeelding.vue?vue&type=template&id=53664146&"
import script from "./Afbeelding.vue?vue&type=script&lang=js&"
export * from "./Afbeelding.vue?vue&type=script&lang=js&"
import style0 from "./Afbeelding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Afbeelding.vue"
export default component.exports